import { Tooltip } from '~/components';
import { useIntegrations } from '~/contexts';
import { accountingProviders } from '~/lookups';
import qboIcon from '~/assets/public/qbo-icon.png';
import xeroIcon from '~/assets/public/xero-icon.png';
import React from 'react';
import styled from 'styled-components';

const icons = { qbo: qboIcon, xero: xeroIcon };

const Wrapper = styled.div`
  width: 1rem;
  height: 1rem;
  margin-left: 0.5rem;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`;

const Image = styled.img`
  width: 1rem;
  height: 1rem;
`;

function getDeepLink(payment, integrations) {
  switch (payment.accountingProvider) {
    case 'xero': {
      if (!payment.xeroPaymentId) return null;
      const orgCode = integrations.xero?.find((c) => c.id === payment.accountingConnectionId)?.orgCode;
      return orgCode
        ? `https://go.xero.com/organisationlogin/default.aspx?shortcode=${orgCode}&redirecturl=/Bank/ViewTransaction.aspx?bankTransactionID=${payment.xeroPaymentId}`
        : `https://go.xero.com/Bank/ViewTransaction.aspx?bankTransactionID=${payment.xeroPaymentId}`;
    }
    default:
      return null;
  }
}

export default function PaymentSyncIndicator({ payment, message }) {
  const integrations = useIntegrations();
  if (!payment.accountingProvider) return null;
  const accountingProviderName = accountingProviders[payment.accountingProvider].name;

  const deepLink = getDeepLink(payment, integrations);
  const defaultMessage = `This payment is in ${payment.accountingConnectionName || accountingProviderName}.`;

  const handleClick = deepLink
    ? (event) => {
        event.stopPropagation();
        window.open(deepLink, '_blank');
      }
    : undefined;

  return (
    <Wrapper $clickable={!!deepLink} onClick={handleClick}>
      <Tooltip message={message ?? defaultMessage}>
        <Image src={icons[payment.accountingProvider]} />
      </Tooltip>
    </Wrapper>
  );
}
